export default __webpack_public_path__ + "static/media/classic3.2d60288c.jpg";